import styleSheet from "./style.module.scss";
import { ContainerProps } from "./sy-overlay-container-interface";
import { useState } from "react";
import SySlide from "../sy-slide";

const SyOverlayContainer = (props: ContainerProps) => {
  const {
    children,
    open,
    direction="up",
    height,
    background = height === "full" ? "dark-transparent" : "dark",
  } = props;

  const {
    bg,
    bg_transparent,
    overlay_container,
    overlay_container_full,
    bg_light,
    overlay_container_notic
  } = styleSheet;

  const [display, setDisplay] = useState("");

  const getBgColor = () => {
    switch (background) {
      case "dark":
        return bg;
      case "dark-transparent":
        return bg_transparent;
      case "light":
        return bg_light;
      default:
        return bg;
    }
  };

  const onTransitionStart = () => {
    setDisplay("");
  };
  const onTransitionEnd = () => {
    setDisplay("d-none");
  };
  return (
    <div
      className={`${
        height === "full" ? overlay_container_full :height === "notic" ? overlay_container_notic : overlay_container
      } w-100  border-0 ${open ? "" : display}`}
    >
      <SySlide
        open={open}
        direction={direction}
        timeout={700}
        onTransitionEnd={onTransitionEnd}
        onTransitionStart={onTransitionStart}
      >
        <div
          className={`${
            height === "full" ? overlay_container_full :height === "notic" ? overlay_container_notic :  overlay_container
          } ${getBgColor()} w-100`}
        >
          
          {children}
        </div>
      </SySlide>
    </div>
  );
};

export default SyOverlayContainer;
